window.sendga = (gl) => {
    if (typeof gtag === 'undefined') {
        console.log('クリック計測', 'ver6特設ページ', gl);
    }
    else {
        gtag('event', 'クリック計測', {
            event_category: 'ver6特設ページ',
            event_label: gl,
            value: 1
        });
    }
};
export const sendga = window.sendga;
